import { useNotificationStore } from '@/stores/helpers/notification.js'
import i18n from '@/i18n/i18n.js'
import Retailer from '@/utilities/retailerHelper.js'

const { t } = i18n.global

// Keeps a retailer off the create page of a flex sales line whose channel is closed. The create
// pages send their first request while they load, so the page must not be entered at all.
export default function retailerClosedSalesChannelBlocker(to, _, next) {
  if (Retailer.isSalesApplicationRouteOpen(to.name) === true) {
    next()
    return
  }

  useNotificationStore().add({
    type: 'danger',
    message: t('views.layouts.sales_channel_closed')
  })

  next({
    name: 'retailer.dashboard'
  })
}
